<template>

    <ThemeChanger :to="Theme.Pink">

        <Container v-if="!formSubmitted" fluid class="pt-32 md:pt-48">

            <PageHeader :header="cms.heading" :subHeader="cms.content"/>

            <Grid :columns="[ 2, 6 ]" class="mt-12 md:mt-24">

                <Column :span="[ 2, 4 ]" :push="[ 0, 1 ]">

                    <AOS type="fade-up" duration="1300" offset="-1000" anchor-placement="top-bottom" delay="650">

                        <DynamicForm :data="contactForm" class="w-full" @success="formSubmitted = true"/>

                    </AOS>

                </Column>

            </Grid>

        </Container>

        <Container v-else fluid class="pt-32 md:pt-40">

            <Grid>

                <Column :span="[ 2, 4 ]" :push="[ 0, 1 ]" class="items-center">

                    <Checkmark/>

                    <Heading tag="h2" class="mt-5">
                        Message successfully sent.
                    </Heading>

                    <Paragraph class="text-grey-400 mt-10 w-full text-center" v-html="lang.message_sent"/>

                    <Button purple class="mt-12" large @click="resetForm">

                        {{ lang.sent_button_text }}

                    </Button>

                </Column>

            </Grid>

        </Container>

    </ThemeChanger>

    <ThemeChanger :to="Theme.Dark">

        <Grid v-if="cms.related_cases" class="mt-32 md:mt-48">

            <AOS type="fade" easing="ease" :duration="800" :delay="300">

                <Column :span="[ 2, 4 ]">

                    <Paragraph v-html="cms.related_cases_title" heading/>

                    <Heading tag="h2" class="mt-16" v-html="cms.related_cases_heading"/>

                </Column>

            </AOS>

        </Grid>

        <Projects v-if="cms.related_cases" :data="cms.related_cases" class="mt-24"/>

    </ThemeChanger>

    <MetaInfo v-if="cms.seo" :seo="cms.seo" :structured-data="cms.seo_structured_data"/>

</template>

<script lang="ts">

    import { defineComponent, ref, getCurrentInstance } from 'vue'
    import Button from '../components/Button.vue'
    import Container from '../components/Container.vue'
    import DynamicForm from '../components/Form/DynamicForm.vue'
    import Column from '../components/Grid/Column.vue'
    import Grid from '../components/Grid/Grid.vue'
    import Checkmark from '../components/Icons/Checkmark.vue'
    import PageHeader from '../components/PageHeader.vue'
    import Heading from '../components/Heading.vue'
    import Paragraph from '../components/Paragraph.vue'
    import Projects from '../components/Projects.vue'
    import ThemeChanger from '../components/ThemeChanger.vue'
    import { currentActiveBreakPoint } from '../compositions/UseResponsiveValue'
    import { useTranslation } from '../compositions/UseTranslation'
    import { useCms } from '../compositions/UseCms'
    import { Breakpoint } from '../enums/Breakpoint'
    import { Theme } from '../enums/Theme'
    import { InputType } from '../enums/InputType'
    import { useTheme } from '../compositions/UseTheme'
    import MetaInfo from '../components/MetaInfo.vue'

    export default defineComponent({
        name: 'Contact',
        components: {
            MetaInfo,
            Container,
            PageHeader,
            Heading,
            Grid,
            DynamicForm,
            Projects,
            Column,
            Paragraph,
            Button,
            Checkmark,
            ThemeChanger
        },
        setup() {

            useTheme().initializeCurrentThemeBasedOnRouteMeta()

            const refreshAOSHard = getCurrentInstance()?.appContext.config.globalProperties.$aos?.refreshHard

            const { contact } = useTranslation()
            const { newContact, contactForm } = useCms()
            const formSubmitted = ref(false)

            return {
                lang: contact,
                cms: newContact,
                contactForm,
                currentActiveBreakPoint,
                Breakpoint,
                Theme,
                formSubmitted,
                InputType,
                resetForm: function() {

                    formSubmitted.value = false
                    refreshAOSHard()

                }
            }

        }
    })

</script>
